import { render, staticRenderFns } from "./ButtonPrimaryForwardIcon.vue?vue&type=template&id=30607a0e&scoped=true"
import script from "./ButtonPrimaryForwardIcon.vue?vue&type=script&lang=js"
export * from "./ButtonPrimaryForwardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30607a0e",
  null
  
)

export default component.exports